
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Calendar, Clock } from 'lucide-react';
import { format } from 'date-fns';

interface GameHistoryTabProps {
  gameHistory: any[];
}

const GameHistoryTab = ({ gameHistory }: GameHistoryTabProps) => {
  return (
    <Card className="mt-4">
      <CardHeader>
        <CardTitle>Game History</CardTitle>
        <CardDescription>
          Your recent game sessions
        </CardDescription>
      </CardHeader>
      <CardContent>
        {gameHistory.length === 0 ? (
          <p className="text-center py-6 text-gray-500">You haven't played any games yet</p>
        ) : (
          <div className="space-y-4">
            {gameHistory.map((game) => (
              <div key={game.id} className="flex justify-between items-start border-b border-gray-100 pb-4">
                <div>
                  <h3 className="font-medium">{game.game_title}</h3>
                  <div className="flex items-center text-sm text-gray-500 mt-1">
                    <Calendar className="h-3 w-3 mr-1" />
                    <span>{format(new Date(game.started_at), 'PPP')}</span>
                    <Clock className="h-3 w-3 ml-3 mr-1" />
                    <span>{format(new Date(game.started_at), 'p')}</span>
                  </div>
                </div>
                <div className="text-sm">
                  {game.completed_at ? (
                    <div className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs">
                      Completed ({game.duration_seconds ? `${Math.round(game.duration_seconds / 60)} mins` : 'N/A'})
                    </div>
                  ) : (
                    <div className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full text-xs">
                      Not completed
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default GameHistoryTab;
